  <!-- Google Tag Manager (noscript) -->
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PMNSFZS"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
<router-outlet></router-outlet>

<!-- somewhere in your root component template -->
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>